(function (w, $) {

    const assetId = '~/theme/v1/Views/Menu/MegaMenu.min.js';

    if (!w.umwAssets || !w.umwAssets[assetId]) {
        console.error('No context found for ' + assetId);
        return;
    }

    for (let ctx of w.umwAssets[assetId]) {

        const prefixClass = "uc203-full-width";

        const classes = {
            control: "js-" + prefixClass,
            lvl1Item: "js-" + prefixClass + "-lvl1-item",
            popup: prefixClass + "-popup",
            lvl1ItemContaisSublevel: prefixClass + "-lvl1-item.has-submenu",
            lvl1ItemHovered: prefixClass + "-lvl1-item-hovered",
        };

        const beforeMegaMenuLvl1Mouseenter = new $.Event("megamenu:lvl1:beforemouseenter");
        const beforeMegaMenuLvl1Mouseleave = new $.Event("megamenu:lvl1:beforemouseleave");
        const desktopHeaderContainer = document.querySelector('.site-header-desktop'); //Global for this control. Is part of Default.aspx

        const $control = $("." + classes.control);
        const $lvl1Item = $("." + classes.lvl1Item, $control);
        const hoverDelay = 250;
        let hoverTimerId;

        $control.on("mouseenter", "." + classes.lvl1Item, function(e) {

            $control.trigger(beforeMegaMenuLvl1Mouseenter, [hoverTimerId, hoverDelay]);

            if (beforeMegaMenuLvl1Mouseenter.isDefaultPrevented()) {
                return;
            }

            clearInterval(hoverTimerId);

            hoverTimerId = setTimeout(function() {
                $lvl1Item.removeClass(classes.lvl1ItemHovered);
                
                $(e.currentTarget).addClass(classes.lvl1ItemHovered);
                
                if($(e.currentTarget).hasClass('has-submenu')) {
                    const hoveredLevel1PopupContainer = e.currentTarget.querySelector('.' + classes.popup);
                    const heightHeaderAndMegaMenu = desktopHeaderContainer.clientHeight + hoveredLevel1PopupContainer.clientHeight;
                    if (heightHeaderAndMegaMenu > window.innerHeight) {
                        hoveredLevel1PopupContainer.classList.add('scrollable');
                        hoveredLevel1PopupContainer.style.height = `calc(${window.innerHeight * .9 - desktopHeaderContainer.clientHeight}px)`;
                    }
                    $('body').addClass('uc203-hovered');
                } else {
                    $('body').removeClass('uc203-hovered');
                }
            },
            hoverDelay);
        });

        $control.on("mouseleave", "." + classes.lvl1Item, function(e) {

            $control.trigger(beforeMegaMenuLvl1Mouseleave, [hoverTimerId, hoverDelay]);

            if (beforeMegaMenuLvl1Mouseleave.isDefaultPrevented()) {
                return;
            }

            clearInterval(hoverTimerId);

            hoverTimerId = setTimeout(function () {
                $lvl1Item.removeClass(classes.lvl1ItemHovered);
                $('body').removeClass('uc203-hovered');
            },
            hoverDelay);
        });
    }

})(window, jQuery);